(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-post-landing-complete"] && !Shopify.designMode) return;
  try {
    
/**
 * ============================================================================
 * BLOG POST LANDING - INTERACTIVE FUNCTIONALITY
 * ============================================================================
 * 
 * DESKTOP BEHAVIOR (990px+):
 * - Hover over title = show image to right, title indents, arrow slides in
 * - Uses CSS :hover for instant response
 * 
 * TABLET BEHAVIOR (750-989px):
 * - Same as desktop but with adjusted sizing
 * 
 * MOBILE BEHAVIOR (<750px):
 * - Shows small thumbnail next to title
 * - Tap title/thumbnail = expand excerpt + "read blog" link below
 * - Tap again = navigate to blog post
 * - Clean, simple interaction
 * 
 * ============================================================================
 */

class BlogPostLanding {
  constructor() {
    // Find all blog post items that have excerpts (mobile only cares about this)
    this.items = document.querySelectorAll('.blog-post-item[data-has-excerpt="true"]');
    
    // Check if we're on mobile (under 750px)
    this.isMobile = window.innerWidth < 750;
    
    // Track which item is currently active on mobile
    this.activeItem = null;
    
    // Exit if no blog posts found
    if (this.items.length === 0) return;
    
    // Initialize functionality
    this.init();
  }
  
  /**
   * INITIALIZE
   * Set up mobile tap handlers and resize detection
   */
  init() {
    // Only set up tap handlers on mobile
    if (this.isMobile) {
      this.setupMobileTapHandlers();
    }
    
    // Handle screen rotation and browser resize
    this.setupResizeHandler();
    
    // Debug log
    console.log('Blog Post Landing initialized:', {
      itemCount: this.items.length,
      isMobile: this.isMobile
    });
  }
  
  /**
   * MOBILE TAP HANDLERS
   * On mobile, tapping toggles the expanded excerpt
   * First tap = expand excerpt + read blog link
   * Second tap = navigate to blog post
   */
  setupMobileTapHandlers() {
    this.items.forEach(item => {
      const contentWrapper = item.querySelector('.blog-post-content-wrapper');
      if (!contentWrapper) return;
      
      // Listen for taps on the entire content area (thumbnail + title)
      contentWrapper.addEventListener('click', (e) => {
        const isCurrentlyActive = item.classList.contains('is-active');
        
        if (!isCurrentlyActive) {
          // FIRST TAP: Expand the excerpt
          e.preventDefault();
          
          // Close any other open items
          this.closeAllItems();
          
          // Open this item
          item.classList.add('is-active');
          this.activeItem = item;
          
          console.log('Expanded excerpt');
        } else {
          // SECOND TAP: Allow navigation
          // Let the link work normally - do nothing
          console.log('Navigating to blog post');
        }
      });
    });
  }
  
  /**
   * CLOSE ALL ITEMS
   * Collapses all expanded excerpts on mobile
   */
  closeAllItems() {
    this.items.forEach(item => {
      item.classList.remove('is-active');
    });
    this.activeItem = null;
  }
  
  /**
   * HANDLE WINDOW RESIZE
   * Switch between mobile and desktop modes when screen size changes
   */
  setupResizeHandler() {
    let resizeTimer;
    
    window.addEventListener('resize', () => {
      // Debounce: wait 250ms after resize stops
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        const wasMobile = this.isMobile;
        this.isMobile = window.innerWidth < 750;
        
        // If switched between mobile and desktop
        if (wasMobile !== this.isMobile) {
          console.log('Screen mode changed to:', this.isMobile ? 'mobile' : 'desktop');
          
          // Close all items
          this.closeAllItems();
          
          // Re-initialize for new screen size
          if (this.isMobile) {
            this.setupMobileTapHandlers();
          }
        }
      }, 250);
    });
  }
  
  /**
   * CLEANUP
   * Remove all active states and event listeners
   */
  destroy() {
    this.closeAllItems();
    console.log('Blog Post Landing destroyed');
  }
}

// ============================================================================
// INITIALIZE WHEN PAGE LOADS
// ============================================================================

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new BlogPostLanding();
  });
} else {
  new BlogPostLanding();
}

// ============================================================================
// SHOPIFY THEME EDITOR SUPPORT
// ============================================================================

if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => {
    new BlogPostLanding();
  });
  
  document.addEventListener('shopify:section:unload', () => {
    // Cleanup handled by destroy() method if needed
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-test"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ekoa-collection-template"] && !Shopify.designMode) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-no-sidebar"] && !Shopify.designMode) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
